import { Component, OnInit } from '@angular/core';
import { Router, RouteReuseStrategy } from '@angular/router';
import { CacheRouteReuseStrategy } from '../../cache-router-reuse-strategy';
import { LeakedFileCheker } from '../../common/tasker/leaked-file-checker';

@Component({
  selector: 'ngx-logout',
  template: '',
})
export class LogoutComponent implements OnInit {
  constructor(private router: Router, 
    private leakedFileCheker: LeakedFileCheker,
    private routerResume: RouteReuseStrategy) {}

  ngOnInit() {
    this.leakedFileCheker.stop();
    (<CacheRouteReuseStrategy>this.routerResume).clearHandlers();
    sessionStorage.clear();
    this.router.navigate(['auth/login']);
  }
}
